import "../styles/Contacts.css";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";
import { FaInstagram, FaLinkedin } from "react-icons/fa";
import { useEffect, useRef, useState } from "react";
import emailjs from "emailjs-com";

export default function Contacts() {
    const ADDRESS_1 = "Roma — Circonvallazione Gianicolense, 78";
    const ADDRESS_2 = "Guglionesi (CB) — Via Giuseppe Manente, 3";

    const formRef = useRef();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const validate = (form) => {
        const fd = new FormData(form);
        const get = (k) => (fd.get(k) || "").toString().trim();

        const nextErrors = {};
        if (!get("name")) nextErrors.name = "Inserisci il nome";
        if (!get("surname")) nextErrors.surname = "Inserisci il cognome";

        const email = get("email");
        const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (!email) nextErrors.email = "Inserisci l'email";
        else if (!emailOk) nextErrors.email = "Email non valida";

        if (!get("subject")) nextErrors.subject = "Inserisci l'oggetto";
        if (!get("message")) nextErrors.message = "Inserisci il messaggio";

        return nextErrors;
    };

    const sendEmail = (e) => {
        e.preventDefault();
        const form = formRef.current;

        const nextErrors = validate(form);
        setErrors(nextErrors);

        if (Object.keys(nextErrors).length > 0) {
            const firstErrorEl = form.querySelector(".has-error input, .has-error textarea");
            if (firstErrorEl) firstErrorEl.focus();
            return;
        }

        emailjs
            .sendForm(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                formRef.current,
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            )
            .then(() => {
                alert("Messaggio inviato con successo!");
                form.reset();
                setErrors({});
            })
            .catch((error) => {
                console.error(error);
                alert("Errore durante l'invio, riprova più tardi.");
            });
    };

    return (
        <main className="contacts">
            <section className="contacts-hero">
                <div className="contacts-container">
                    <h1 className="contacts-title">Contatti</h1>
                    <p className="contacts-subtitle">Prenota la tua visita o scrivimi per informazioni.</p>
                </div>
            </section>

            <section className="contacts-body">
                <div className="contacts-container">
                    <aside className="contacts-info">
                        <div className="info-block">
                            <div className="info-row">
                                <MdLocationOn className="icon pin" aria-hidden />
                                <div className="info-text">
                                    <em>{ADDRESS_1.split(" — ")[0]}</em> — {ADDRESS_1.split(" — ")[1]}
                                </div>
                            </div>
                            <div className="info-row">
                                <MdLocationOn className="icon pin" aria-hidden />
                                <div className="info-text">
                                    <em>{ADDRESS_2.split(" — ")[0]}</em> — {ADDRESS_2.split(" — ")[1]}
                                </div>
                            </div>
                        </div>

                        <hr />

                        <div className="info-block">
                            <div className="info-row">
                                <MdEmail className="icon" aria-hidden />
                                <div className="info-text">
                                    <a href="mailto:lamanda.nutrizionista@gmail.com" aria-label="Email">
                                        lamanda.nutrizionista@gmail.com
                                    </a>
                                </div>
                            </div>
                        </div>

                        <hr />

                        <div className="info-block">
                            <div className="info-row">
                                <MdPhone className="icon" aria-hidden />
                                <div className="info-text">
                                    <a href="tel:+393792069823" aria-label="Email">
                                        +39 379 206 9823
                                    </a>
                                </div>
                            </div>
                        </div>

                        <hr />

                        <div className="socials">
                            <a href="https://www.instagram.com/thefueldoctor/" aria-label="Instagram" className="social-btn">
                                <FaInstagram size={18} />
                            </a>
                            <a href="https://www.linkedin.com/in/giammarco-lamanda-a9323a178/" aria-label="LinkedIn" className="social-btn">
                                <FaLinkedin size={18} />
                            </a>
                            <a href="mailto:lamanda.nutrizionista@gmail.com" aria-label="Email" className="social-btn">
                                <MdEmail size={20} />
                            </a>
                            <a href="tel:+393792069823" aria-label="Phone" className="social-btn">
                                <MdPhone size={20} />
                            </a>
                        </div>
                    </aside>

                    <section className="contacts-form">
                        <form ref={formRef} onSubmit={sendEmail} aria-label="Modulo di contatto" noValidate>
                            <div className={`field ${errors.name ? "has-error" : ""}`}>
                                <label htmlFor="name">Nome</label>
                                <input id="name" name="name" type="text" placeholder="Il tuo nome" aria-invalid={!!errors.name} required />
                                {errors.name && <p className="error-text">{errors.name}</p>}
                            </div>

                            <div className={`field ${errors.surname ? "has-error" : ""}`}>
                                <label htmlFor="surname">Cognome</label>
                                <input id="surname" name="surname" type="text" placeholder="Il tuo cognome" aria-invalid={!!errors.surname} required />
                                {errors.surname && <p className="error-text">{errors.surname}</p>}
                            </div>

                            <div className={`field ${errors.email ? "has-error" : ""}`}>
                                <label htmlFor="email">Email</label>
                                <input id="email" name="email" type="email" placeholder="La tua email" aria-invalid={!!errors.email} required />
                                {errors.email && <p className="error-text">{errors.email}</p>}
                            </div>

                            <div className={`field ${errors.subject ? "has-error" : ""}`}>
                                <label htmlFor="subject">Oggetto</label>
                                <input id="subject" name="subject" type="text" placeholder="Perché mi contatti?" aria-invalid={!!errors.subject} required />
                                {errors.subject && <p className="error-text">{errors.subject}</p>}
                            </div>

                            <div className={`field ${errors.message ? "has-error" : ""}`}>
                                <label htmlFor="message">Messaggio</label>
                                <textarea id="message" name="message" rows={8} placeholder="Inserisci qui il tuo messaggio" aria-invalid={!!errors.message} required />
                                {errors.message && <p className="error-text">{errors.message}</p>}
                            </div>

                            <button type="submit" className="btn-submit">INVIA MESSAGGIO</button>
                        </form>
                    </section>
                </div>
            </section>
        </main>
    );
}
